export const ShopStatus = {
  OFFLINE: 9999, // 9999 店铺下线
  OUT_OF_RANGE: 9998, // 9998 超出配送范围
  ONLINE: 3, // 3 店铺营业中
  CLOSED: 4, // 4 店铺休息中
} as const;

export const RENDER_TYPE = {
  /** 子包 */
  SUB: 'sub',
  /** 自定义组件 */
  CUSTOM: 'custom',
} as const;

export const STICKY_TYPE = {
  /** 不吸顶 （默认）*/
  normal: 0,
  /** 吸顶 */
  STICKY: 1,
} as const;
